<template>
<div class="chapter">
<div class="inner_page">
<div class="page-background-image"><img alt="image" src="images/page001.jpg"/></div>
<div class="page001text1">SAMMY SPIDER’S</div>
<div class="page001text2">SHAVUOT</div>
<div class="page001text3">Sylvia A. Rouss</div>
<div class="page001text4">illustrated by<br/><span class="ftbig">Katherine Janus Kahn</span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// page001.vue?4f4d27a9